<template>
    <v-container>
        
        <v-card>
            <v-card-title>navigator: {{ navigatorLanguage }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; locale: {{ locale }}</v-card-title>
            <v-card-text>{{ $t('general.hello', { name: name }) }}</v-card-text>
            <v-card-actions>
                <v-btn @click="changeLang()">{{ $t('general.changeLang') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>


</template>

<script>
export default {
    data(){
        return {
            name: 'Fabio',
            navigatorLanguage: navigator.languages,
        }
    },

    computed: {
        locale(){
            return this.$i18n.locale
        }
    },

    methods: {
        changeLang(){
            if(this.$i18n.locale == 'it') 
                this.$i18n.locale = 'en'
            else
                this.$i18n.locale = 'it'
        }
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Test.vue